export default __webpack_public_path__ + "static/media/IMG_1870 copie.749e4e39.jpg";